import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Controllers from '../../Api/Controllers'
import Helpers from '../../Components/Helpers/Helpers'
import { ListPageShell, EmptyState } from '../../Components/Ui'
import parse from 'html-react-parser'
import { useSelector } from 'react-redux'
import ReactPlaceholder from 'react-placeholder/lib'

const avatarFallback = (e) => {
    e.currentTarget.style.display = 'none'
    if (e.currentTarget.nextSibling) e.currentTarget.nextSibling.style.display = 'inline-flex'
}

const sectionTitle = {
    margin: '0 0 14px',
    fontSize: '1.05rem',
    fontWeight: 800,
    color: '#201030'
}

const Searching = _ => {
    const { keyword } = useParams()
    const store = useSelector(store => store)

    const [rows, setRows] = useState({
        articles: [],
        events: [],
        foros: [],
        notis: [],
        courses: [],
    })
    const [ready, setReady] = useState(false)

    useEffect(_ => {
        Controllers.dashboard.get_searching({
            p_keyword: keyword
        }).then(res => {
            setRows(res.data)
            setReady(true)
        })
    }, [keyword])

    const hasResults = rows.articles.length || rows.events.length || rows.notis.length || rows.foros.length || rows.courses.length

    return (
        <ListPageShell
            eyebrow="Super Papelera — Espacio de trabajo"
            title="Resultados de búsqueda"
            subtitle={keyword ? `Coincidencias para “${keyword}”.` : 'Busca en blog, eventos, noti, foro y cursos.'}
            badge="Buscador"
        >
            <ReactPlaceholder ready={ready} showLoadingAnimation rows={10}>
                {hasResults ? (
                    <div style={{ padding: '8px 4px 12px' }}>
                        {rows.articles.length ? (
                            <div className="mb-4">
                                <h3 style={sectionTitle}>Balance de Vida</h3>
                                {React.Children.toArray(rows.articles.map(a => (
                                    <Link
                                        className="sp-feed-card"
                                        to={Helpers.config.convertUrl({ url: '/blog/' + a.token_article })}
                                    >
                                        {a.file_images ? (
                                            <img
                                                src={Helpers.config.resourcesUrl({ url: a.file_images })}
                                                width="64"
                                                height="64"
                                                alt=""
                                                style={{ borderRadius: 12, objectFit: 'cover', flexShrink: 0 }}
                                            />
                                        ) : null}
                                        <div style={{ minWidth: 0, flex: 1 }}>
                                            <h6>{a.name_article}</h6>
                                            <div style={{ marginBottom: 6 }}>{parse(a.content_article)}</div>
                                            <small className="sp-comment-meta">
                                                {a.date_article} · {a.name_category} · {a.qty_comment_article} comentarios
                                            </small>
                                        </div>
                                        <i className="fa fa-chevron-right align-self-center" style={{ color: '#9CA3AF' }} />
                                    </Link>
                                )))}
                            </div>
                        ) : null}

                        {rows.events.length ? (
                            <div className="mb-4">
                                <h3 style={sectionTitle}>Eventos</h3>
                                {React.Children.toArray(rows.events.map(a => (
                                    <Link
                                        className="sp-feed-card"
                                        to={Helpers.config.convertUrl({ url: '/evento/' + a.token_event })}
                                    >
                                        {a.file_images ? (
                                            <img
                                                src={Helpers.config.resourcesUrl({ url: a.file_images })}
                                                width="64"
                                                height="64"
                                                alt=""
                                                style={{ borderRadius: 12, objectFit: 'cover', flexShrink: 0 }}
                                            />
                                        ) : null}
                                        <div style={{ minWidth: 0, flex: 1 }}>
                                            <h6>{a.name_event}</h6>
                                            <div style={{ marginBottom: 6 }}>{parse(a.content_event)}</div>
                                            <small className="sp-comment-meta">
                                                {a.date_event} · {a.name_category} · {a.qty_comment_event} comentarios
                                            </small>
                                        </div>
                                        <i className="fa fa-chevron-right align-self-center" style={{ color: '#9CA3AF' }} />
                                    </Link>
                                )))}
                            </div>
                        ) : null}

                        {rows.notis.length ? (
                            <div className="mb-4">
                                <h3 style={sectionTitle}>Noti Súper</h3>
                                {React.Children.toArray(rows.notis.map(a => (
                                    <Link
                                        className="sp-feed-card"
                                        to={Helpers.config.convertUrl({ url: '/noti/' + a.token_noti })}
                                    >
                                        {a.file_images ? (
                                            <img
                                                src={Helpers.config.resourcesUrl({ url: a.file_images })}
                                                width="64"
                                                height="64"
                                                alt=""
                                                style={{ borderRadius: 12, objectFit: 'cover', flexShrink: 0 }}
                                            />
                                        ) : null}
                                        <div style={{ minWidth: 0, flex: 1 }}>
                                            <h6>{a.name_noti}</h6>
                                            <div style={{ marginBottom: 6 }}>{parse(a.content_noti)}</div>
                                            <small className="sp-comment-meta">
                                                {a.date_noti} · {a.name_category} · {a.qty_comment_noti} comentarios
                                            </small>
                                        </div>
                                        <i className="fa fa-chevron-right align-self-center" style={{ color: '#9CA3AF' }} />
                                    </Link>
                                )))}
                            </div>
                        ) : null}

                        {rows.foros.length ? (
                            <div className="mb-4">
                                <h3 style={sectionTitle}>Foros</h3>
                                {React.Children.toArray(rows.foros.map(r => (
                                    <Link
                                        className="sp-feed-card"
                                        to={Helpers.config.convertUrl({ url: '/foro/' + r.token_foro })}
                                    >
                                        <div style={{ position: 'relative' }}>
                                            <img
                                                src={Helpers.config.resourcesUrl({ url: r.file_photo_foro })}
                                                width="48"
                                                height="48"
                                                alt=""
                                                style={{ borderRadius: 999, objectFit: 'cover' }}
                                                onError={avatarFallback}
                                            />
                                            <span className="sp-avatar-fallback" style={{ display: 'none', width: 48, height: 48 }}>
                                                <i className="fa fa-user" />
                                            </span>
                                        </div>
                                        <div style={{ minWidth: 0, flex: 1 }}>
                                            <h6>{r.name_foro}</h6>
                                            <p>{r.observation_foro}</p>
                                            <small className="sp-comment-meta">{r.date_created}</small>
                                        </div>
                                        <i className="fa fa-chevron-right align-self-center" style={{ color: '#9CA3AF' }} />
                                    </Link>
                                )))}
                            </div>
                        ) : null}

                        {rows.courses.length ? (
                            <div className="mb-2">
                                <h3 style={sectionTitle}>Cursos</h3>
                                <div className="form-row">
                                    {React.Children.toArray(rows.courses.map(v => (
                                        <section className="col-12 col-sm-6 col-md-3 mb-4">
                                            {v.categories.includes(store.session.id_category) ? (
                                                <Link
                                                    to={Helpers.config.convertUrl({ url: '/buscador-de-videos/' + v.token_video })}
                                                    style={{ textDecoration: 'none' }}
                                                >
                                                    <div style={{
                                                        borderRadius: 16,
                                                        border: '1px solid #E5E7EB',
                                                        overflow: 'hidden',
                                                        background: '#fff'
                                                    }}>
                                                        <img
                                                            src={Helpers.config.resourcesUrl({ url: v.file_images })}
                                                            width="100%"
                                                            height="150"
                                                            alt=""
                                                            style={{ objectFit: 'cover', display: 'block' }}
                                                        />
                                                        <div style={{ padding: 12 }}>
                                                            <h6 style={{ margin: 0, color: '#201030', fontWeight: 700, textAlign: 'center', fontSize: '0.88rem' }}>
                                                                {v.name_course}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </Link>
                                            ) : (
                                                <div style={{
                                                    opacity: 0.55,
                                                    cursor: 'not-allowed',
                                                    borderRadius: 16,
                                                    border: '1px solid #E5E7EB',
                                                    overflow: 'hidden',
                                                    background: '#fff'
                                                }}>
                                                    <img
                                                        src={Helpers.config.resourcesUrl({ url: v.file_images })}
                                                        width="100%"
                                                        height="150"
                                                        alt=""
                                                        style={{ objectFit: 'cover', display: 'block' }}
                                                    />
                                                    <div style={{
                                                        padding: 12,
                                                        minHeight: 70,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <h6 style={{ margin: 0, color: '#201030', fontWeight: 700, textAlign: 'center', fontSize: '0.88rem' }}>
                                                            {v.name_course}
                                                        </h6>
                                                        <strong style={{ color: '#C41022', fontSize: '0.75rem', marginTop: 4 }}>
                                                            No pertenece a tu área
                                                        </strong>
                                                    </div>
                                                </div>
                                            )}
                                        </section>
                                    )))}
                                </div>
                            </div>
                        ) : null}
                    </div>
                ) : (
                    <EmptyState
                        icon="fa fa-search"
                        title="Sin coincidencias"
                        text="No se han encontrado resultados para esta búsqueda."
                    />
                )}
            </ReactPlaceholder>
        </ListPageShell>
    )
}

export default Searching
